export default "__VITE_ASSET__4bd201f6__"